import Home from '../pages/Home.svelte';
import Cards from '../pages/Cards.svelte';
import { JanusInternationalizationManagerToken, JanusInternationalizationManager } from './i18n';
import { getToken } from 'inversify-token';
import ROOT from '../inversify.config';
import { Writable, writable } from 'svelte/store';
import { f7, f7ready } from 'framework7-svelte';
import SignIn from '../pages/SignIn.svelte';
import { JanusSignonManagerToken } from './sso';


const i18nManager = getToken(ROOT, JanusInternationalizationManagerToken);
const currentLanguage = i18nManager.getCurrentLanguage();
const homeRedirect = `/pages/${currentLanguage}/DropLobby?backButton=false`;
let languageUnsubscribe = null;
const enableLanguageUrlSwitch = (to, from, resolve, reject) => {
  const initialLang = to.params.lang;
  console.log('SET CURRENT LANGUAGE', initialLang);
  i18nManager.setCurrentLanguage(initialLang);
  // Listen for changes in language and change route as needed
  // we need to subscribe on the next tick because the setCurrentLanguage value may not have passed through to the store yet
  setTimeout(() => languageUnsubscribe = i18nManager.getCurrentLanguageStore().subscribe((lang) => {
    console.log('LANGUAGE CHANGE', lang);
    if (lang !== initialLang) {
      f7.views.main.router.navigate({
        name: to.name,
        params: { ...to.params, lang },
        query: (Object.keys(to.query).length)? to.query : undefined
      }, {
        //clearPreviousHistory: true
      });
    }
  }), 0);
  resolve();
};
const disableLanguageUrlSwitch = (to, from, resolve, reject) => {
  if (languageUnsubscribe) {
    languageUnsubscribe();
    languageUnsubscribe = null;
  }
  resolve();
};

const signonManager = getToken(ROOT, JanusSignonManagerToken);
const checkSignedIn = async (to, from, resolve, reject) => {
  // only check for DropLobby page
  console.log('CHECK SIGNED IN FOR ROUTE', to.name, to.params.listName);
  const isDropLobbyPage = (to.name === 'page-with-slug' || to.name === 'page') && to.params.listName === 'DropLobby';
  if (!isDropLobbyPage) {
    console.log('NOT DROP LOBBY PAGE');
    resolve();
    return;
  }

  // check sign-in status
  const status = signonManager.getStatus();
  if (status.loggedIn) {
    console.log('USER SIGNED IN', status);
    resolve();
    return;
  }

  // redirect to sign-in page
  reject();
  f7.views.main.router.navigate({
    name: 'signin',
    query: { 
      redirectTo: to.url 
    }
  });
};

export interface Route {
  query: { [key: string]: string };
  params: { [key: string]: string };
  url: string;
  path: string;
  // this is the route's source configuration (from the routes array below)
  route: {
    name: string;
    path: string;
  }
  name: string;
}

// This is set by YCApp.svelte
export const currentRoute: Writable<Route> = writable(null);

// WARNING: Redirects break prerendering for the website. Don't use redirects here unless absolutely necessary.
const routes = [
  {
    path: '/',
    component: Home
    //redirect: homeRedirect
  },
  /* ???: For some reason the alias feature was not working, so defined these as separate paths. */
  {
    name: 'home',
    path: '/home',
    component: Home,
    //redirect: homeRedirect
  },
  {
    path: '/index.html',
    component: Home,
    //redirect: homeRedirect
  },
  {
    name: 'signin',
    path: '/signin',
    component: SignIn,
  },
  {
    name: 'page-with-slug',
    path: '/pages/:lang/:listName/:path1',
    component: Cards,
    beforeEnter: [ enableLanguageUrlSwitch, checkSignedIn ],
    beforeLeave: disableLanguageUrlSwitch
  },
  {
    name: 'page',
    path: '/pages/:lang/:listName',
    component: Cards,
    beforeEnter: [ enableLanguageUrlSwitch, checkSignedIn ],
    beforeLeave: disableLanguageUrlSwitch
  },
  {
    path: '(.*)',
    redirect: homeRedirect
    //component: NotFoundPage,
  },
];

export default routes;
